<template>
  <a-modal
    :title="title"
    :width="1250"
    :centered="true"
    :visible="visible"
    :footer="null"
    :destroyOnClose="true"
    @cancel="handleCancel"
    wrapClassName="track-modal-wrapper"
  >
    <div style="display: flex; width: 1250px">
      <!-- フロー図 -->
      <div class="track-wrapper graph">
        <img :src="src" style="padding-bottom: 30px" />
      </div>

      <!-- タイムライン -->
      <div class="track-wrapper timeline">
        <HistoryOperation :processInstanceId="processInstanceId"></HistoryOperation>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { getAction } from '@/api/manage'
import HistoryOperation from '@/views/k00/k0011/modules/HistoryOperation'

export default {
  name: 'TrackModal',
  components: { HistoryOperation },
  data() {
    return {
      title: '流程履历',
      visible: false,
      processInstanceId: '',
      src: '',
    }
  },
  computed: {
    src() {
      return (
        window._CONFIG['domianURL'] +
        '/flow/processTracking?processInstanceId=' +
        this.processInstanceId +
        '&locale=' +
        Vue.ls.get('Locale') +
        '&_t=' +
        Date.now()
      )
    },
  },
  created() {},
  methods: {
    open(processInstanceId, title) {
      this.visible = true
      this.processInstanceId = processInstanceId

      if (title) {
        this.title = title
      }

      this.src =
        window._CONFIG['domianURL'] +
        '/flow/processTracking?processInstanceId=' +
        this.processInstanceId +
        '&locale=' +
        Vue.ls.get('Locale') +
        '&_t=' +
        Date.now()
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>

<style lang="less">
.track-modal-wrapper {
  overflow-y: hidden;

  .ant-modal-content {
    height: 100%;

    .ant-modal-body {
      max-height: calc(100vh - 70px);
      //background: #f3f3f3;
      border-radius: 0 0 4px 4px;
      padding: 0;
      overflow: hidden;
    }
  }

  .track-wrapper {
    height: calc(50vh - 93px);
    overflow: auto;
    background: rgba(255, 255, 255, 5%);
    border-radius: 0px;
    padding: 18px 16px 18px 20px;
    width: 350px;
    height: 659px;
    max-height: calc(100vh - 110px);
    background: white;
  }

  .track-wrapper.graph {
    background-image: linear-gradient(
        0deg,
        transparent 14px,
        rgba(204, 204, 204, 0.2) 14.5px,
        rgba(204, 204, 204, 0.2) 15px,
        transparent 15.1px,
        transparent 29px,
        rgba(204, 204, 204, 0.2) 29.5px,
        rgba(204, 204, 204, 0.2) 30px,
        transparent 30.1px,
        transparent 44px,
        rgba(204, 204, 204, 0.2) 44.5px,
        rgba(204, 204, 204, 0.2) 45px,
        transparent 45.1px,
        transparent 59px,
        rgba(204, 204, 204, 0.8) 60px
      ),
      linear-gradient(
        90deg,
        transparent 14px,
        rgba(204, 204, 204, 0.2) 14.5px,
        rgba(204, 204, 204, 0.2) 15px,
        transparent 15.1px,
        transparent 29px,
        rgba(204, 204, 204, 0.2) 29.5px,
        rgba(204, 204, 204, 0.2) 30px,
        transparent 30.1px,
        transparent 44px,
        rgba(204, 204, 204, 0.2) 44.5px,
        rgba(204, 204, 204, 0.2) 45px,
        transparent 45.1px,
        transparent 59px,
        rgba(204, 204, 204, 0.8) 60px
      );
    background-size: 60px 60px;
    width: 900px;
    padding: 0;
    background-position-y: -1px;
    border-right: 1px solid var(--color-tb-border);
  }
}
</style>
